import { TransitionStatus } from 'react-transition-group';
import styled from 'styled-components';
import { getThemeColor } from 'utils/styled';
import {
  TAB_PANEL_CLASSNAME,
  TAB_PANEL_TRANSITION_DURATION_MILLIS,
  TAB_TRANSITION,
  TAB_UNDERLINE_HEIGHT_PX,
} from './constants';
import BaseTabPanel from './TabPanel';

export interface IndicatorProps {
  $selectedIndex: number;
  $tabCount: number;
}

export interface TabPanelStyleProps {
  transitionState: TransitionStatus;
}

export const TabList = styled.div`
  border-bottom: 2px solid ${getThemeColor('d4')};
  border-radius: 1px;
  display: flex;
  position: relative;
`;

export const Indicator = styled.div<IndicatorProps>`
  background-color: ${getThemeColor('actionPrimary')};
  border-radius: 1px;
  height: ${TAB_UNDERLINE_HEIGHT_PX}px;
  bottom: -${TAB_UNDERLINE_HEIGHT_PX}px;
  position: absolute;
  width: ${(props) => `calc(100% / ${props.$tabCount})`};
  transform: translateX(${(props) => `${props.$selectedIndex * 100}%`});
  // very specific transition.  spec was to copy that of MUI's tabs
  transition: ${TAB_TRANSITION};
`;

export const TabPanel = styled(BaseTabPanel)`
  transition: ${({ theme }) =>
    theme.transitions.create(
      'opacity',
      `${TAB_PANEL_TRANSITION_DURATION_MILLIS}ms`,
      'ease-in-out',
    )};

  &.${TAB_PANEL_CLASSNAME}-enter {
    opacity: 0;
  }

  &.${TAB_PANEL_CLASSNAME}-enter-active {
    opacity: 1;
  }

  &.${TAB_PANEL_CLASSNAME}-exit {
    opacity: 0;
  }

  &.${TAB_PANEL_CLASSNAME}-exit-active {
    opacity: 0;
  }
`;
